const messages = {
  video: {
    title: 'Sumérjase en un universo poético y artístico',
    cta: 'Ver el trailer'
  },
  keypoints: {
    point1: 'Una inmersión en un universo poético y artístico',
    point2: 'Explore los grandes principios de la creación contemporánea',
    point3: 'Navegue a través de la mayor colección de arte moderno y contemporáneo de Europa'
  },
  themes: {
    title1: 'Color y sistema',
    content1: 'En este nivel, dividido en dos sistemas visuales, hay que reunir los colores, más allá del espejo, siguiendo un principio de simetría.',
    title2: 'Color y emoción',
    content2: 'Un mundo sin color es un mundo que no existe. Coloree cada rincón de este nivel para revelar su estructura y reconstruir el entorno. ',
    title3: 'Luz y física',
    content3: 'La luz puede convertirse en un marcador físico en el espacio. Use la huella de luz de su avatar para generar un pasadizo para acceder a áreas que antes estaban fuera de alcance. La luz no sólo genera sombras, sino también caminos que resultan ser reales.',
    title4: 'Luz e inmersión ',
    content4: 'La luz puede fusionarse con el espacio. Encuentre un equilibrio entre su huella de luz y su sombra. Su movimiento en el espacio produce formas inesperadas hasta revelar una sombra que resulta ser su propia creación. ',
    title5: 'Color y espiritualidad',
    content5: 'Pasee por este colorido espacio con formas abstractas, donde cada área debe ser activada con el objeto y el color correctos. Intente  encontrar las correspondencias más allá del simbolismo de las formas y los códigos de color.',
    title6: 'Color y compromiso',
    content6: ' En un universo con forma de metrópolis deshumanizada, los habitantes de la ciudad son un recurso que permite descubrir ciertos pasajes y la ciudad se convierte en un gran mecanismo manipulable.',
    title7: 'Color y función',
    content7: 'En una obra, un color puede tener su propia función, su propio referente. En este nivel, cada color se refiere a una función específica. Asigne un color a todos los objetos que no lo tienen. '
  },
  prod: {
    text1: 'Producido gracias al apoyo del Ministerio de Educación y Juventud',
    text2: 'Un juego desarrollado por el Centre Pompidou, Game in Society y Bright, con una banda sonora escrita especialmente por Ircam Amplify',
    link: 'Enlace al comunicado de prensa'
  },
  available: {
    date: 'Disponible ahora'
  },
  download: {
    exe: 'Descargar archivo ejecutable'
  }
}

export default messages
